<template>
    <Page withNavbar withNavigation>
        <header>
            <section class="picture">
                <Picture :src="config.BRIEF_REWARD_IMAGE_MOBILE || config.BRIEF_REWARD_IMAGE" :ratio="1" :size="pictureSize"/>
            </section>
        </header>
        <main>
            <section class="text">
                <h4>{{ config.BRIEF_REWARD_TITLE }}</h4>
                <p v-html="config.BRIEF_REWARD_DESCRIPTION"/>
            </section>
            <SectionActions>
                <Button :color="config.COLOR_PRIMARY" :to="{ name: next }" :disabled="disabled">
                    {{ config.BRIEF_REWARD_CTA }}
                </Button>
            </SectionActions>
        </main>
    </Page>
</template>
<script>
import { SolutionConsumer } from '../../mixins';
import { Page } from '../../components/mobile';
import { SectionActions } from '../../components/shared';

export default {
    name: 'BriefReward',
    components: { Page, SectionActions },
    mixins: [SolutionConsumer],
    props: {
        next: {
            type: String,
            required: true,
        },
        pictureCover: {
            type: Boolean,
            default: false,
        },
        /**
         * Whether to disable the CTA button
         */
        disabled: {
            type: [Boolean, String],
            default: false,
        },
    },
    computed: {
        pictureSize () {
            return this.pictureCover ? 'cover' : 'contain';
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

main {
    @include container(40px 20px);
}
</style>
